
export const handleValidationErrors = (e, formikRef) => {
    const {errors} = e.data;
    Object.keys(errors).forEach(function (key) {
        formikRef.current.setFieldError(key, errors[key][0]);
    });
}

export const handleScroll = (errors) => {
    const arrayError = Object.keys(errors)
    if (arrayError.length) {
        const field = document.getElementsByName(arrayError[0])[0]
        field?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
}
